var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wind-hazard-getting-started"}},[_c('TheTopBar',{attrs:{"showUser":""}}),_c('div',{staticClass:"row"},[_c('InfoCards',{attrs:{"data-info-cards":_vm.infoCardsData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }